// extracted by mini-css-extract-plugin
module.exports = {"authors-wrapper":"authors-list-module__authors-wrapper__Rqlly"};